<template>
    <div class="na-form">

        <div v-if="post" class="left">


            <div class="dx-fieldset">
                <div class="dx-field">
                    <div class="dx-field-label">
                        Id:
                    </div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.NotId' :readOnly="true" />
                    </div>

                </div>

                <div class="dx-field">
                    <div class="dx-field-label">Id of Idea:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.FK_TopicId' :readOnly="true" />
                    </div>
                </div>


                <div class="dx-field">
                    <div class="dx-field-label">Sender Mail Adress:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.NotFrom' :readOnly="true" />
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">Receiver Mail Adress:</div>
                    <div class="dx-field-value">
                        <DxTextArea :value='post.NotRecipient' :readOnly="true" />
                    </div>
                </div>

                <div class="dx-field">
                    <div class="dx-field-label">Sent on:</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='post.NotSendedOn' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Subject</div>
                    <div class="dx-field-value">
                        <DxTextArea :value='post.NotSubject' :readOnly="true" />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Message</div>
                    <div class="dx-field-value">
                        <div class="NotHtml" v-html="post.NotBody">
                        </div>
                    </div>
                </div> 
                <div class="na-buttons-row">
                    <div>
                        <DxButton text="Close"
                                  type="default"
                                  styling-mode="outlined"
                                  @click="onCloseClick($event)" />
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>


<script>
    import axios from "axios";
    // @ is an alias to /src

    import { DxTextBox, DxTextArea } from 'devextreme-vue';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import '../assets/detailForm.less';
    import $ from 'jquery';

    const baseUri = "WebApi.asmx/api/notificationService";
    export default {
        name: 'NotificationDetail',
        components: {

            DxButton,
            DxTextBox,
            DxTextArea,
            DxDateBox,
        },
        data() {
            return {
                post: null,
            };
        },
        created: function () {
            axios
                .get(baseUri + '/GetDetailNL')
                .then(res => {
                    this.post = res.data.data 
                })
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onClick(e) {
                const buttonText = e.component.option('text');
                notify(`The ${this.capitalize(buttonText)} button was clicked`);
            },
            capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
        }
    }


</script>
<style>
    .NotHtml {
        background: #eaeaea;
        padding: 20px;
        border-bottom: solid 1px silver;
    }
   
</style>
